/** A Sealed save threw on its way: it may have gone through, so the list is read again. */
export const SEALED_SAVE_FAILED_ON_THE_WAY = "Something went wrong while saving. Check the list before trying again.";
